
// Test data for Level 3 Driver Training

export const driverTests = [
  {
    id: "driver-precision",
    title: "Driver - Précision sur la mise en jeu",
    description: "Sur le practice choisir une cible en fond de practice et jouer 10 balles sur l'axe de jeu. Calculez vos points en fonction de la précision de votre coup.",
    icon: "🎯"
  }
];

// Définition du calcul des points
export const driverScoringGuide = {
  balleAxe: 6, // Balle +- dans l'axe: 6 points
  balle6m: 4, // Balle à +- 6m autour de l'axe de jeu: 4 points
  balle10m: 2, // Balle à +- 10m autour de l'axe de jeu: 2 points
  balleHors: 0 // Balle hors zone: 0 point
};
